import {useNavigate, useParams} from "react-router-dom";
import HeaderAIChatbot from '~/components/Layout/components/HeaderAIChatbot';
import React, {Fragment, useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPen} from "@fortawesome/free-solid-svg-icons";
import styles from './AIChatbot.module.scss';
import classNames from "classnames/bind";
import {useEffect, useState} from "react";
import AwsChatbotAPI from '~/api/awsChatbotApi';
import {CenteredModal} from '~/components';
import {usePlanFeature} from '~/pages/context/PlanFeatureContext';
import {toast} from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import pcm16Base64ToFloat32 from "./utils/pcm16Base64ToFloat32";
import useVoiceChatRecorder from "./hooks/useAudioAutoStopRecorder";
import UpgradePlanRequest from './component/UpgradePlanRequest';
import awsChatbotApi from "~/api/awsChatbotApi";
import ChatSidebar from "./component/ChatSidebar";
import ChatBody from "./component/ChatBody";
import ChatFooter from "./component/ChatFooter";
import './wave.css';
import * as signalR from "@microsoft/signalr";
const cx = classNames.bind(styles);
function AIChatbot(){
    const { id } = useParams();
    const [newChat, setNewChat] = useState(false);
    const [sessionsChat, setSessionsChat] = useState([]);
    const [sessionId, setSessionId] = useState(id);
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState("");
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [sessionTitle, setSessionTitle] = useState("");
    const [sessionTitleInput, setSessionTitleInput] = useState("");
    const [collapse, setCollapse] = useState(false);
    const [activeMessageId, setActiveMessageId] = useState(-1);
    const [isSending, setIsSending] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [showModalUpgradePlan, setShowModalUpgradePlan] = useState(false);
    const [upgradePlanId, setUpgradePlanId] = useState(0);
    const [showModalRecording, setShowModalRecording] = useState(false);
    const [, setToggleAudio] = useState(null);
    const [playing, setPlaying] = useState(false);
    const [connection, setConnection] = useState(null);
    const textareaRef = useRef(null);
    const chatEndRef = useRef(null);
    const navigate = useNavigate();
    const divRef = useRef(null);
    const {planFeature} = usePlanFeature();
    const [speakingMessageIndex, setSpeakingMessageIndex] = useState(null);
    const botPlaybackRef = useRef({
        audioContext: null,
        playTime: 0,
        activeTtsSources: [],
        activeVoiceSources: [],
        currentTtsMessageIndex: null
    });
    const chatQuestionsDefault = [
        "What is love?",
        "What is success?",
        "How can you gain long-life success, health, and happiness?",
        "How can I stay healthy?",
        "What is pseudo-success?"
    ];
    const apiUrl = process.env.REACT_APP_API_URL;

    const compareDate = () => {
        const nowUtc = new Date();
        const serverUtcDate = new Date(planFeature.EndDate + "Z");
        return serverUtcDate < nowUtc
    }

    useEffect(() => {
        let connection;

        const ensureAudioContext = () => {
            const ref = botPlaybackRef.current;
            if (!ref.audioContext || ref.audioContext.state === "closed") {
                ref.audioContext = new AudioContext({ sampleRate: 24000 });
                ref.playTime = ref.audioContext.currentTime;
            }
        };

        const stopAllPlayback = (resetUi = true) => {
            const ref = botPlaybackRef.current;

            const stopSources = (sources) => {
                sources.forEach((src) => {
                    try {
                        src.stop();
                        src.disconnect();
                    } catch {}
                });
                return [];
            };

            ref.activeTtsSources = stopSources(ref.activeTtsSources);
            ref.activeVoiceSources = stopSources(ref.activeVoiceSources);

            if (ref.audioContext && ref.audioContext.state !== "closed") {
                ref.playTime = ref.audioContext.currentTime;
            }

            ref.currentTtsMessageIndex = null;
            if (resetUi) setSpeakingMessageIndex(null);
        };

        const playPcm16Base64 = (base64Pcm, kind) => {
            ensureAudioContext();
            const ref = botPlaybackRef.current;
            const audioContext = ref.audioContext;
            if (!audioContext) return;
            // If user stopped/cancelled TTS, ignore any late-arriving chunks.
            if (kind === "tts" && ref.currentTtsMessageIndex === null) return;

            const float32 = pcm16Base64ToFloat32(base64Pcm);
            if (float32.length === 0) return;

            const buffer = audioContext.createBuffer(1, float32.length, 24000);
            buffer.copyToChannel(float32, 0);

            const source = audioContext.createBufferSource();
            source.buffer = buffer;
            source.connect(audioContext.destination);

            if (ref.playTime < audioContext.currentTime) {
                ref.playTime = audioContext.currentTime;
            }

            if (kind === "tts") {
                if (ref.activeTtsSources.length === 0 && ref.currentTtsMessageIndex !== null) {
                    setSpeakingMessageIndex(ref.currentTtsMessageIndex);
                }
            }

            source.start(ref.playTime);
            ref.playTime += buffer.duration;

            if (kind === "tts") {
                ref.activeTtsSources.push(source);
            } else {
                ref.activeVoiceSources.push(source);
            }

            source.onended = () => {
                if (kind === "tts") {
                    ref.activeTtsSources = ref.activeTtsSources.filter(s => s !== source);
                    if (ref.activeTtsSources.length === 0) {
                        ref.currentTtsMessageIndex = null;
                        setSpeakingMessageIndex(null);
                    }
                } else {
                    ref.activeVoiceSources = ref.activeVoiceSources.filter(s => s !== source);
                }
            };
        };

        const start = async () => {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(`${apiUrl}/api/voiceChatHub`, { withCredentials: true })
                .withAutomaticReconnect()
                .build();

            connection.on("ReceiveTextVoiceChat", () => {});

            connection.on("ReceiveAudioChunkVoiceChat", (base64Pcm) => {
                playPcm16Base64(base64Pcm, "voice");
            });

            connection.on("ReceiveAudioChunk", (base64Pcm) => {
                playPcm16Base64(base64Pcm, "tts");
            });

            connection.on("TtsCompleted", () => {});

            connection.on("ReceiveActionVoiceChat", (actionName) => {
                if (actionName === "stop") {
                    stopAllPlayback(true);
                }
            });

            try {
                await connection.start();
                setConnection(connection);
            } catch (err) {
                console.error("SignalR connect error", err);
            }
        };

        start();

        return () => {
            if (connection) connection.stop();
            stopAllPlayback(false);
            const ref = botPlaybackRef.current;
            if (ref.audioContext && ref.audioContext.state !== "closed") {
                ref.audioContext.close();
            }
        };
    }, []);

    const { startRecording, stopRecording } = useVoiceChatRecorder(connection);

    useEffect(() => {
        AwsChatbotAPI.getChatSessionByUserId()
            .then((res) => {
                const grouped = _.groupBy(res.data, "Classifications");
                setSessionsChat(grouped);
            })
            .catch((err) => {
            });
    }, [sessionTitle]);

    useEffect(() => {
        if(sessionId && !newChat){
            const params = new URLSearchParams({
                userId: "0",
                sessionId: sessionId,
            });
            AwsChatbotAPI.getChatHistoryBySessionId(params)
                .then((res) => {
                    const parsedData = res.data.map(item => ({
                        ...item,
                        ShowButtons: true,
                        ChatButtons:
                            item.ChatButtons && item.ChatButtons.startsWith("[")
                                ? JSON.parse(item.ChatButtons)
                                : []
                    }));
                    setMessages(parsedData);
                    if(res.data.length <= 0){
                        navigate('/ai-chatbot/chat', { replace: true });
                    }
                })
                .catch((err) => {
                });
        }
        else {
            if(newChat){
                setNewChat(false);
            }
            setMessages([])
        }
        const el = divRef.current;
        if (el) {
            const style = window.getComputedStyle(el);
            if (style.display === "none") {
                handleToggleCollapse();
            }
        }

    }, [sessionId]);


    const handleInput = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto"; // reset
            textarea.style.height = Math.min(textarea.scrollHeight, 130) + "px";
        }
    };

    const handleMessageInput = async (message, isMessageInput, messageValue) => {
        if(compareDate())
        {
            setUpgradePlanId(1);
            setShowModalUpgradePlan(true);
            return;
        }
        if (isTyping) {
            return;
        }
        setIsTyping(true);
        const trimmed = message.trim();
        if (!trimmed) return;
        let newSessionId = '';
        if(messages.length <= 0){
            setNewChat(true);
            newSessionId = uuidv4();
            setSessionId(newSessionId);
            window.history.pushState({}, "", `/ai-chatbot/chat/${newSessionId}`);
            const data = {
                SessionId: newSessionId,
                Title: message.substring(0, 100)
            }
            await AwsChatbotAPI.insChatSessionTitle(data);
            setSessionTitle(message.substring(0, 100));
        }

        setMessages((prev) => [
            ...prev,
            { ChatTypeId: 1, ChatContent: trimmed },
        ]);
        const dataInsert = {
            SessionId: newSessionId === '' ? sessionId : newSessionId,
            ChatContent: trimmed,
            ChatTypeId: 1,
        }
        AwsChatbotAPI.insAwsChatHistory(dataInsert);
        if(isMessageInput){
            setMessageInput("");
        }
        await handleRecognizeTextAsync(trimmed, newSessionId === '' ? sessionId : newSessionId, messageValue, isMessageInput);
    }

    const handleSendMessage = async () => {
        await handleMessageInput(messageInput, true, messageInput);
    }

    const handleRecognizeTextAsync = async (textInput, currentSessionId, messageValue, isMessageInput) => {
        if (textInput === "") return;
        setIsSending(true);

        let chatContent = "";
        let newButtons = [];

        awsChatbotApi.getAnswer({TextInput : textInput, TextValue: isMessageInput ? "" : messageValue})
            .then(async (res) => {
                const resData = res.data;
                if (resData.IsRandomText){
                    chatContent = "Looks like you might have typed something by mistake! How can I help you today?";
                    newButtons = [];
                }
                else {
                    chatContent = resData.ContentTranslate;
                    newButtons = resData.ButtonListTranslate.map(item => ({
                        Text: item.text,
                        Value: item.value
                    }));
                }
            })
            .catch((err) => {
                chatContent = "Looks like you might have typed something by mistake! How can I help you today?";
                newButtons = [];
            })
            .finally(() => {
                setIsSending(false);
                setMessages((prev) => [
                    ...prev,
                    {
                        ChatTypeId: 2,
                        ChatContent: chatContent,
                        ChatButtons: newButtons,
                        IsNew: true,
                        ShowButtons: false,
                    },
                ]);
                const data = {
                    SessionId: currentSessionId,
                    ChatContent: chatContent,
                    ChatTypeId: 2,
                    ChatButtons: JSON.stringify(newButtons)
                }
                AwsChatbotAPI.insAwsChatHistory(data)
                    .then((res) => {
                        connection.invoke("UpdatePrevChatHistoryId", res.data.ReturnValue);
                    });
            })
    }

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth", block: 'end' });
    }, [messages]);

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            await handleSendMessage();
        }
    };

    const handleChatButton = async (buttonValue, buttonText) => {
        await handleMessageInput(buttonText, false, buttonValue);
    };

    const handleConfirmDelete = () => {

    }

    const handleConfirmEdit = () => {
        if(sessionTitleInput.trim() === "") return;

        const data = {
            SessionId: sessionId,
            Title: sessionTitleInput.trim()
        }
        AwsChatbotAPI.updChatSessionTitle(data)
            .then((res) => {
                setSessionTitle(sessionTitleInput.trim());
                toast.success(<span className="fs-9 fw-bold">Title has been updated.</span>);
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating title.</span>)
                ;
            })
            .finally(() => {
                setShowModalEdit(false);
            })
        ;
    }

    const handleNewChatSession = () => {
        setSessionId("");
        navigate('/ai-chatbot/chat', { replace: true });
    }

    const handleToggleCollapse = () => {
        const html = document.documentElement; // <html>
        html.classList.toggle("navbar-vertical-collapsed");
        setCollapse(prev => !prev);
    }

    const handleMessageClick = (index) => {
        if(isTyping) return;
        if(activeMessageId === index || window.innerWidth > 768) return;
        setActiveMessageId(index);
    }

    const handleMouseEnter = (index) => {
        if(isTyping) return;
        if(window.innerWidth > 768){
            setActiveMessageId(index);
            setToggleAudio(prev => !prev);
        }
    }
    const handleMouseLeave = () => {
        if(isTyping) return;
        if(window.innerWidth > 768){
             setActiveMessageId(null);
             setToggleAudio(prev => !prev);
        }
    }

    const handleCopyMessage = (messageContent) => {
        navigator.clipboard.writeText(messageContent)
            .then(() => {
            })
            .catch(err => {
            });
    };

    const handleTextToSpeech = (messageContent, messageId) => {
        const ref = botPlaybackRef.current;

        // Toggle off if user clicks the same message while it's speaking.
        if (speakingMessageIndex === messageId) {
            ref.activeTtsSources.forEach((src) => {
                try {
                    src.stop();
                    src.disconnect();
                } catch {}
            });
            ref.activeTtsSources = [];
            ref.currentTtsMessageIndex = null;
            setSpeakingMessageIndex(null);
            return;
        }

        // Stop previous playback to avoid overlapping audio.
        ref.activeTtsSources.forEach((src) => {
            try {
                src.stop();
                src.disconnect();
            } catch {}
        });
        ref.activeVoiceSources.forEach((src) => {
            try {
                src.stop();
                src.disconnect();
            } catch {}
        });
        ref.activeTtsSources = [];
        ref.activeVoiceSources = [];

        ref.currentTtsMessageIndex = messageId;
        setSpeakingMessageIndex(messageId);

        connection?.invoke("StartTextToSpeech", messageContent).catch(() => {});
    };

    const handleVoiceChat = () => {
        setShowModalRecording(true);
    }

    const handleRepeatMessage = (messageContent) => {
        setMessageInput(messageContent);
    }

    const updateMessageAtIndex = (index, updates) => {
        setMessages((prev) =>
            prev.map((msg, i) => (i === index ? { ...msg, ...updates } : msg))
        );
    };

    

    const handleStartVoiceChat = (isStart) => {
        if (isStart) {
            startRecording();
        }
        else {
            stopRecording();
        }
        setPlaying(isStart);
    }

    const handleCloseVoiceChat = () => {
        setShowModalRecording(false);
        setPlaying(false);
    }

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "end"
        });
    };

    if(planFeature.CurrentServicePlanId === 0)
    {
        navigate('/auth/locked-screen', { replace: true });
    }

    return (
        <Fragment>
            {
                planFeature.CurrentServicePlanId > 0 &&
                <Fragment>
                    <ChatSidebar
                        collapse={collapse}
                        sessionsChat={sessionsChat}
                        sessionId={sessionId}
                        divRef={divRef}
                        onToggleCollapse={handleToggleCollapse}
                        onNewChatSession={handleNewChatSession}
                        onSelectSession={(session) => {
                            setSessionId(session.SessionId);
                            window.history.pushState({}, "", `/ai-chatbot/chat/${session.SessionId}`);
                        }}
                        onRequestEdit={(session) => {
                            setShowModalEdit(true);
                            setSessionTitleInput(session.Title);
                        }}
                        onRequestDelete={() => setShowModalDelete(true)}
                    />
                    <HeaderAIChatbot isShowButtonToggle={true} toggleOnClick={handleToggleCollapse}/>
                    <div className={cx('chat-container', 'content pe-3 ps-3')}>
                        <ChatBody
                            messages={messages}
                            isSending={isSending}
                            chatEndRef={chatEndRef}
                            chatQuestionsDefault={chatQuestionsDefault}
                            activeMessageId={activeMessageId}
                            speakingMessageIndex={speakingMessageIndex}
                            onChatButton={handleChatButton}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            onMessageClick={handleMessageClick}
                            onCopyMessage={handleCopyMessage}
                            onRepeatMessage={handleRepeatMessage}
                            onTextToSpeech={handleTextToSpeech}
                            onTypingComplete={(index) => {
                                updateMessageAtIndex(index, {
                                    IsNew: false,
                                    ShowButtons: true
                                });
                                setIsTyping(false);
                                scrollToBottom();
                            }}
                        />
                        <ChatFooter
                            textareaRef={textareaRef}
                            handleInput={handleInput}
                            messageInput={messageInput}
                            setMessageInput={setMessageInput}
                            handleKeyDown={handleKeyDown}
                            handleVoiceChat={handleVoiceChat}
                            handleSendMessage={handleSendMessage}
                        />
                    </div>
                    <CenteredModal show={showModalDelete} title="Delete chat" onClose={() => setShowModalDelete(false)}
                                   confirmText="Delete" onConfirm={handleConfirmDelete}>
                        <span className="fs-9 fw-bold">Are you sure you want to remove this chat?</span>
                    </CenteredModal>

                    <CenteredModal show={showModalEdit} title="Edit chat title" onClose={() => setShowModalEdit(false)}
                                   confirmText="Save Changes" onConfirm={handleConfirmEdit}>
                        <div className="form-icon-container">
                            <div className="form-floating">
                                <input value={sessionTitleInput} className="form-control form-icon-input"
                                       id="emailSocial" type="email" placeholder="Email"
                                       onChange={(e) => setSessionTitleInput(e.target.value)}/>
                                <label className="text-body-tertiary form-icon-label" htmlFor="emailSocial">ENTER NEW
                                    TITLE</label>
                            </div>
                            <FontAwesomeIcon icon={faPen} className='form-icon fs-9 text-body'/>
                        </div>
                    </CenteredModal>

                    <UpgradePlanRequest typeId={upgradePlanId} setShowModal={setShowModalUpgradePlan} showModal={showModalUpgradePlan}/>

                    <CenteredModal
                        show={showModalRecording}
                        title=""
                        onClose={() => setShowModalRecording(false)}
                        closeText=""
                        modalType="modal-fullscreen"
                        modalContentClass="opacity-85"
                    >
                        <div className="d-flex h-70 justify-content-center align-items-center">
                            <div className={`speaker ${playing ? "active" : "paused"}`}>
                                <span className="wave"></span>
                                <span className="wave"></span>
                                <span className="wave"></span>
                                <span className="wave big"></span>
                                <span className="wave big"></span>
                                <div className="core"></div>
                            </div>
                        </div>
                        <p className="fs-9 text-center">
                            Press Start to begin speaking and Stop to finish and wait for the system’s response. <br/>
                            The system will automatically stop if you remain silent for 10 seconds.
                        </p>
                        <div className="text-center">
                            <button onClick={() => handleStartVoiceChat(true)} className="btn-speaker me-4 bg-success fw-bold text-white">Start</button>
                            <button onClick={() => handleStartVoiceChat(false)} className="btn-speaker me-4 bg-danger fw-bold text-white">Stop</button>
                            <button onClick={handleCloseVoiceChat} className="btn-speaker fw-bold">Close</button>
                        </div>
                    </CenteredModal>
                </Fragment>
            }
        </Fragment>
    )
}

export default AIChatbot
